import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
// import { IS_SP } from '../const/config';

import { SplideTextAnimation } from './../modules/TextAnimation'

// 処理が重いらしいので
// HomeSlider と OtherSlider に分割し、読み込みControllerを分けます

// トップページ用スライダー
export class HomeSlider {
  constructor() {
    this.DOM = {};
    this.DOM.sliderElements = document.querySelectorAll('[data-home-slider]');
    if (this.DOM.sliderElements.length === 0) return;

    this.options = {}; // オプション設定
    this.mounts = {}; // マウントの設定
    this.splide = {}; // 作成後のsplideインスタンスを格納する
    // 例：
    // this.splide = [
    //  'homeAbout' : [ new splide() ],
    //  'homeInterview' : [ new splide() , new splide() , new splide() ],
    // ]


    this.setVariable();
    this.init();
  }
  setVariable(){
    // オプションを設定する
    this.options = {
      // MV
      'homeMv': {
        type      : 'fade',
        arrows    : false,
        drag      : false,
        speed     : 1500,
        rewind    : true,
        focus     : 'center',
        perPage   : 1,
        autoplay  : false,
        interval  : 5000,
        pagination: true,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      // プレサンスについて
      'homeAbout' : {
        autoWidth: true,
        type: 'loop',
        arrows: false,
        pagination: false,
        easing: 'linear',
        autoScroll: {
          speed: 0.4,
          pauseOnHover: false,
          autoStart: true
        },
        drag: false,
      },
      // インタビュー
      'homeInterview': {
        autoWidth : true,
        arrows    : true,
        pagination: true,
        speed     : 800,
        gap       : '2.4rem',
        rewind    : true,
        perPage   : 1,
        trimSpace : false,
        breakpoints: {
          768: { gap: '1.6rem' }
        }
      },
    };
    this.mounts = {
      'homeAbout': {
        AutoScroll
      },
    };
  }

  init() {
    const mvElements = [];
    const otherElements = [];

    this.DOM.sliderElements.forEach((slider) => {
      const name = slider.getAttribute('data-home-slider');
      if (name === 'homeMv') {
        mvElements.push(slider);
      } else {
        otherElements.push(slider);
      }
    });

    // homeMvを最優先でインスタンス化・mountする
    mvElements.forEach((slider) => {
      this.createInstance(slider, 'homeMv');
    });
    this.syncSlider();
    this.mountSliderGroup('homeMv');

    const mountOthers = () => {
      otherElements.forEach((slider) => {
        const name = slider.getAttribute('data-home-slider');
        this.createInstance(slider, name);
      });
      this.syncSlider();
      Object.keys(this.splide).forEach((name) => {
        if (name === 'homeMv') return;
        this.mountSliderGroup(name);
      });
    };

    if (document.readyState === 'complete') {
      window.requestAnimationFrame(mountOthers);
    } else {
      window.addEventListener('load', mountOthers, { once: true });
    }
  }

  // インスタンスを作成して配列に入れる
  createInstance = (slider, name) => {
    // データ属性に紐づくoptionやmountを利用
    const option = this.options[name] ?? [ {type: 'slide'} ];
    // let mount = this.mounts[name] ?? [];
    
    // インスタンスの作成
    const splide = new Splide(slider, option);

    // 同名キーの配列がなければ初期化し、インスタンスを push する
    if (!this.splide[name]) {
      this.splide[name] = [];
    }
    this.splide[name].push(splide);
  }
  
  syncSlider = () => {
    // 例：もし特定の組み合わせを同期させたい場合
    // Array.isArray(this.splide['homeInterview']) を使ってループ処理などが可能になります
  }

  getHomeMvSlideImage(slider, index) {
    const slides = slider.Components?.Elements?.slides;
    if (!slides) return null;
    return slides[index]?.querySelector('img') ?? null;
  }

  whenHomeMvImageReady(img) {
    if (!img) return Promise.resolve();

    img.loading = 'eager';

    const loaded = (img.complete && img.naturalWidth > 0)
      ? Promise.resolve()
      : new Promise((resolve) => {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });

    return loaded.then(() => {
      if (!img.naturalWidth || typeof img.decode !== 'function') return;
      return img.decode().catch(() => {});
    });
  }

  preloadHomeMvImages(slider) {
    slider.root.querySelectorAll('.splide__slide img').forEach((img) => {
      img.loading = 'eager';
    });
  }

  playHomeMvWhenNextReady(slider) {
    const autoplay = slider.Components.Autoplay;
    if (!autoplay) return;

    autoplay.pause();

    const length = slider.length;
    if (!length) return;

    const nextIndex = (slider.index + 1) % length;
    const nextImage = this.getHomeMvSlideImage(slider, nextIndex);

    this.whenHomeMvImageReady(nextImage).then(() => {
      const section = slider.root.closest('.s-homeMv');
      if (!section?.classList.contains('is-ready')) return;
      autoplay.play();
    });
  }

  mountSliderGroup(name) {
    const sliders = this.splide[name];
    if (!sliders) return;

    const mount = this.mounts[name] ?? [];

    sliders.forEach((slider) => {
      // inteview は 数が少なければUI非表示
      if (name === 'homeInterview') {
        slider.on('overflow', (isOverflow) => {
          slider.go(0);
          slider.options.arrows = isOverflow;
          slider.options.pagination = isOverflow;
          slider.options.drag = isOverflow;
          slider.options.clones = isOverflow ? undefined : 0;
        });
      }

      // homeMvはいろいろ追加
      if (name === 'homeMv') {
        slider.on('pagination:mounted', (data) => {
          data.items.forEach((item) => {
            // 各ボタンの中にSVGプログレスサークルを滑り込ませる
            item.button.innerHTML = `
                <svg class="s-homeMv__sliderProgressSvg" viewBox="0 0 32 32">
                  <circle cx="16" cy="16" r="14"></circle>
                </svg>
              `;
          });
        });

        // 自動再生の進捗を監視して、アクティブなドットのサークルを動かす
        slider.on('autoplay:playing', (rate) => {
          // 現在アクティブなボタンの中にあるサークルを取得
          const navigation = slider.root.querySelector('[data-home-slider-navigation]');
          const activeDot = navigation.querySelector('.is-active');
          if (!activeDot) return;
          const circle = activeDot.querySelector('circle');
          if (circle) {
            const maxOffset = 88; // CSSのstroke-dasharrayと同じ値
            // 進捗率（rateは0〜1）を元に、線の引き方を逆算
            const offset = maxOffset - (rate * maxOffset);
            circle.style.strokeDashoffset = offset;
          }
        });

        // スライドが切り替わった瞬間は一旦進捗をリセットする
        slider.on('move', () => {
          const navigation = slider.root.querySelector('[data-home-slider-navigation]');
          const circles = navigation.querySelectorAll('circle');
          circles.forEach((circle) => {
            circle.style.strokeDashoffset = 88;
          });
        });

        // 2. 連動アニメーションクラスを実体化（Splideを渡す）
        // フェードイン開始と同時に再生するため、mounted後の reveal 内で生成する

        // mount後にセクション内要素とスライダーをフェードイン
        slider.on('mounted', () => {
          const section = slider.root.closest('.s-homeMv');
          if (!section) return;

          this.preloadHomeMvImages(slider);

          let revealed = false;
          const reveal = () => {
            if (revealed) return;
            revealed = true;
            new SplideTextAnimation(slider);
            section.classList.add('is-ready');
            this.playHomeMvWhenNextReady(slider);
          };

          const firstImage = this.getHomeMvSlideImage(slider, slider.index)
            || slider.root.querySelector('.splide__slide img');
          this.whenHomeMvImageReady(firstImage).then(reveal);
          window.setTimeout(reveal, 2000);
        });

        slider.on('moved', () => {
          const section = slider.root.closest('.s-homeMv');
          if (!section?.classList.contains('is-ready')) return;
          window.requestAnimationFrame(() => {
            this.playHomeMvWhenNextReady(slider);
          });
        });
      }

      slider.mount(mount);
    });
  }
}

export class OtherSlider {
  constructor() {
    this.DOM = {};
    this.DOM.sliderElements = document.querySelectorAll('[data-slider]');
    if (this.DOM.sliderElements.length === 0) return;

    this.options = {}; // オプション設定
    this.mounts = {}; // マウントの設定
    this.splide = {}; // 作成後のsplideインスタンスを格納する
    // 例：
    // this.splide = [
    //  'homeAbout' : [ new splide() ],
    //  'homeInterview' : [ new splide() , new splide() , new splide() ],
    // ]


    this.setVariable();
    this.init();
  }
  setVariable(){
    // オプションを設定する
    this.options = {
      // インタビュー
      'interview': {
        autoWidth : true,
        arrows    : true,
        pagination: true,
        speed     : 800,
        gap       : '2.4rem',
        rewind    : true,
        perPage   : 1,
        trimSpace : false,
        breakpoints: {
          768: { gap: '1.6rem' }
        }
      },
    };
    this.mounts = {};
  }

  init() {
    // 先にすべてのインスタンスを作成する
    this.DOM.sliderElements.forEach( (slider) => {

      const name = slider.getAttribute('data-slider');

      // インスタンスの作成と配列格納
      this.createInstance(slider, name);

    });

    // スライダー同士のsyncを定義
    this.syncSlider();

    // すべてのスライダー実行
    this.allSliderMount();

  }

  // インスタンスを作成して配列に入れる
  createInstance = (slider, name) => {
    // データ属性に紐づくoptionやmountを利用
    const option = this.options[name] ?? [ {type: 'slide'} ];
    // let mount = this.mounts[name] ?? [];
    
    // インスタンスの作成
    const splide = new Splide(slider, option);

    // 同名キーの配列がなければ初期化し、インスタンスを push する
    if (!this.splide[name]) {
      this.splide[name] = [];
    }
    this.splide[name].push(splide);
  }
  
  syncSlider = () => {
    // 例：もし特定の組み合わせを同期させたい場合
    // Array.isArray(this.splide['homeInterview']) を使ってループ処理などが可能になります
  }
  allSliderMount(){

    // 構造が { name: [splide, splide...] } になったので、2重ループでマウント
    Object.entries(this.splide).forEach(([name, sliders]) => {
      const mount = this.mounts[name] ?? [];

          
      sliders.forEach((slider) => {

        // inteview は 数が少なければUI非表示
        if( name==='interview') {
          slider.on( 'overflow', ( isOverflow ) => {
            slider.go( 0 );
            slider.options.arrows = isOverflow;
            slider.options.pagination = isOverflow;
            slider.options.drag = isOverflow;
            slider.options.clones = isOverflow ? undefined : 0;
          });
        }

        slider.mount(mount);
      });
    });
  }
}
